
import { Component } from "vue-property-decorator";
import { COMPONENT_VISIBILITY } from "../types";
import BaseView from "./BaseView";

@Component
export default class AdminView extends BaseView {
  created() {
    this.setTopBarVisibility(COMPONENT_VISIBILITY.hidden);
  }

  dumpLatestAppSettingsQueries() {
    const latestAppVersion = "1.11.1";
    const appVersionQuery = `
      UPDATE settings SET
        value = '${latestAppVersion}'
      WHERE name = 'public_latest_app_version';
    `;
    console.info(appVersionQuery);

    const latestAppDescriptionObj = {
      en: `
        <div style="font-size: 15px;">
          <div>
            <div style="text-align: center;"><b>NEW UPDATE AVAILABLE</b></div>
            <div style="margin-top: 10px;">
              <div><b class="--red">New: Test!</b></div>
              <div>Test!</div>
            </div>
            <div style="margin-top: 17px;">Update now and explore music from around the world!</div>
          </div>
        </div>
      `,
    };
    const jsonContent = JSON.stringify(latestAppDescriptionObj);
    const latestAppDescription = this.normalizeLatestAppDescription(jsonContent);
    const appDescriptionQuery = `
      UPDATE settings SET
        value = '${latestAppDescription}'
      WHERE name = 'public_latest_app_description';
    `;
    console.info(appDescriptionQuery);
  }

  normalizeLatestAppDescription(jsonContent: string) {
    return jsonContent.replace(/'/g, "''");
  }
}
